/** The message banner piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { MessageBannerEvents } from './contract';
import { MessageBannerView } from './MessageBannerView';
import { useMessageBanner } from './useMessageBanner';

export function MessageBanner(props: PieceInput<MessageBannerEvents>) {
  return <MessageBannerView {...useMessageBanner(props)} />;
}
